import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import ShopLocationIcon from '@/components/icons/shop/Location';
import ShopDirectionIcon from '@/components/icons/shop/DirectionIcon';
import styles from './styles.module.scss';
import { useConfigStore } from '@/stores/configStore';

interface ListTypeDetailActionsProps {
    onQrClick: () => void;
    onDirectionClick: () => void;
    showDirection: boolean;
    showQr: boolean;
    tabIndexBase?: number;
    qrRegionOrder?: number;
    directionRegionOrder?: number;
}

const ListTypeDetailActions = ({ onQrClick, onDirectionClick, showDirection = false, showQr = false, tabIndexBase = 4, qrRegionOrder, directionRegionOrder }: ListTypeDetailActionsProps) => {
    const { t } = useTranslation();
    const screenMode = useConfigStore((s) => s.config?.ui?.screenMode);

    return (
        <div className={styles.actions}>
            {showQr && (
                <button
                    type="button"
                    className={clsx(styles['actions__btn'], 'focus-border', styles['actions__btn--qr'], {
                        [styles['actions__btn--halfmode']]: screenMode === 'split',
                    })}
                    onClick={onQrClick}
                    tabIndex={tabIndexBase}
                    data-interactive
                    aria-label={t('list_type.detail.qr_view')}
                    data-role={t('common.data_role.popup_button')}
                    data-region-nav={qrRegionOrder !== undefined ? true : undefined}
                    data-region-order={qrRegionOrder}
                >
                    <ShopLocationIcon width={20} height={28} />
                    {t('list_type.detail.qr_view')}
                </button>
            )}

            {showDirection && (
                <button
                    type="button"
                    className={clsx(styles['actions__btn'], 'focus-border', styles['actions__btn--direction'], {
                        [styles['actions__btn--halfmode']]: screenMode === 'split',
                    })}
                    onClick={onDirectionClick}
                    tabIndex={tabIndexBase + 1}
                    data-interactive
                    aria-label={t('list_type.detail.direction')}
                    data-role={t('common.data_role.button')}
                    data-region-nav={directionRegionOrder !== undefined ? true : undefined}
                    data-region-order={directionRegionOrder}
                >
                    <ShopDirectionIcon width={24} height={28} />
                    {t('list_type.detail.direction')}
                </button>
            )}
        </div>
    );
};

export default ListTypeDetailActions;
